import Vue from "vue";
import Vuex, { Store } from "vuex";
import createLogger from "./logger";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ["PasswordStore", "SelfDisclosurePersistedStore"]
});

let store: Store<any>;

// import namespaced store modules
import storeModules from "./modules";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

/**
 * @returns {Store<any>}
 */
export function getStore(): Store<any> {
    if (!store) {
        createStore();
    }

    return store;
}

/**
 * @returns {Store<any>}
 */
export function createStore(): Store<any> {
    store =  new Vuex.Store({
        modules: storeModules,
        strict: debug,
        plugins: /* istanbul ignore next */debug ? [createLogger(), vuexLocal.plugin] : [vuexLocal.plugin]
    });

    return store;
}
